<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import Modal from "../../../../components/modals/modal-form.vue";
import api from '../../../../helpers/apirest/api';

import {
    customerComputed,
    targetDriverComputed,
} from "@/state/helpers";

const initialState = () => {
    return {
        submitted: false,
        customer_task: {
            customer_id: '',
            target_driver_id: '',
            description: '',
            error_emails: null,
            success_emails: null,
            last_sync: null,
            project_id: null,
            raw_command: []
        }
    };
}

export default {
    emits: ['onSuccess'],
    props: {
        modalId: String,
        id: Number
    },
    data() {
        return initialState();
    },
    components: {
        Modal
    },
    computed: {
        ...customerComputed,
        ...targetDriverComputed,
    },
    validations: {
        customer_task: {
            customer_id: { required },
            target_driver_id: { required },
            description: { required },
            success_emails: {  },
            error_emails: {  },
            last_sync: { required },
            project_id: { 
                required: requiredIf(function() { 
                    return this.withBigquery 
                }), 
            },
            raw_command: {
                required,
                $each: { required }
            }
        }
    },
    methods: {
        async shown() {

            this.$store.dispatch("customer/loadList");
            this.$store.dispatch("targetDriver/loadList");

            if (this.id) {
                const response = await api.get({
                    url: `customer-tasks/${this.id}`
                });
                this.customer_task = response?.data?.data;
            }
        },
        addRow(){
            this.customer_task.raw_command.push('');
        },
        deleteRow(key){
            this.customer_task.raw_command.splice(key, 1);
        },
        async confirm() {

            this.submitted = true;
            this.$v.$touch();
            console.log(this.$v);

            if (this.$v.$invalid) {
                return;
            }

            const data = this.customer_task;

            await api.save({
                url: 'customer-tasks-raw-command',
                id: this.customer_task?.id,
                data: data 
            });

            this.$bvModal.hide(this.modalId);
            this.$emit("onSuccess");
        },
        cancel() {
            this.$bvModal.hide(this.modalId);
        },
        resetModal() {
            Object.assign(this.$data, initialState());
        }
    }
};
</script>

<template>
    <Modal :title="'Customer task raw command form'" :id="modalId" @confirm="confirm" @cancel="cancel" @shown="shown" @hidden="resetModal" :size="'extra-xl'">
        <div class="row">

            <div class="col-lg-4 col-md-12 col-xs-12 mb-2">
                <div class="card h-100">
                    <div class="card-header bg-secondary">
                        <h4 class="card-title text-white">General</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-md-6 col-xs-12">
                                <label for="customer_id">Customer</label>
                                <select v-model="customer_task.customer_id" class="form-control"
                                    :class="{ 'is-invalid': $v.customer_task.customer_id.$error && submitted }">
                                    <option value="">Select</option>
                                    <option v-for="option in customers" v-bind:value="option.id" :key="option.id">
                                        {{ option.fullname }}
                                    </option>
                                </select>
                                <div v-if="!$v.customer_task.customer_id.required && submitted" class="invalid-feedback">Customer is
                                    required</div>
                            </div>
                            <div class="form-group col-md-6 col-xs-12">
                                <label for="description">Name</label>
                                <input id="description" v-model="customer_task.description" type="text" class="form-control" placeholder="Enter name"
                                    :class="{ 'is-invalid': $v.customer_task.description.$error && submitted }" />
                                <div v-if="!$v.customer_task.description.required && submitted" class="invalid-feedback">Name is required</div>
                            </div>
                            <div class="form-group col-md-6 col-xs-12">
                                <label for="success_emails">Success Emails</label>
                                <input id="success_emails" v-model="customer_task.success_emails" type="text" class="form-control" placeholder="Enter emails separated by commas"
                                    :class="{ 'is-invalid': $v.customer_task.success_emails.$error && submitted }" />
                            </div>
                            <div class="form-group col-md-6 col-xs-12">
                                <label for="error_emails">Error Emails</label>
                                <input id="error_emails" v-model="customer_task.error_emails" type="text" class="form-control" placeholder="Enter emails separated by commas"
                                    :class="{ 'is-invalid': $v.customer_task.error_emails.$error && submitted }" />
                            </div>
                            <div class="form-group col-md-6 col-xs-12">
                                <label for="last_sync">Last sync</label>
                                <input id="last_sync" v-model="customer_task.last_sync" type="datetime-local" class="form-control" placeholder="Enter last sync"
                                    :class="{ 'is-invalid': $v.customer_task.last_sync.$error && submitted }" />
                                <div v-if="!$v.customer_task.last_sync.required && submitted" class="invalid-feedback">Last sync is required</div>
                            </div>
                        </div>                        
                    </div>
                </div>
            </div>            

            <div class="col-lg-8 col-md-6 col-xs-12 mb-2">
                <div class="card h-100">
                    <div class="card-header bg-secondary">
                        <h4 class="card-title text-white">Driver</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="form-group col-12">
                                <label for="target_driver_id">Driver</label>
                                <select v-model="customer_task.target_driver_id" class="form-control"
                                    :class="{ 'is-invalid': $v.customer_task.target_driver_id.$error && submitted }">
                                    <option value="">Select</option>
                                    <option v-for="option in targetDrivers" v-bind:value="option.id" :key="option.id">
                                        {{ option.fullname }}
                                    </option>
                                </select>
                                <div v-if="!$v.customer_task.target_driver_id.required && submitted" class="invalid-feedback">Target Driver is
                                    required</div>
                            </div>
                            <div class="form-group col-lg-6 col-md-12">
                                <label for="project_id">Project id</label>
                                <input id="project_id" v-model="customer_task.project_id" type="text" class="form-control" placeholder="Enter project id"
                                    :class="{ 'is-invalid': $v.customer_task.project_id.$error && submitted }" />
                                <div v-if="!$v.customer_task.project_id.required && submitted" class="invalid-feedback">Project id is required</div>
                            </div>  
                            
                            <div class="col-12">
                                <div class="card h-100">
                                    <div class="card-header card-header-with-action">
                                        <h4 class="card-title">Secquency of commands</h4>
                                        <button type="button" class="btn btn-sm btn-success" v-b-tooltip.hover title="Add field" @click="addRow()"><i class="mdi mdi-plus mr-2"></i></button>
                                    </div>
                                    <div class="card-body table-responsive">
                                        <div v-for="(item, idx) in customer_task.raw_command" :key="idx" :set="v = $v.customer_task.raw_command.$each[idx]">
                                            <div class="input-group mb-2">                                                
                                                <input 
                                                    type="text"
                                                    v-model="customer_task.raw_command[idx]"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': v.$error }"
                                                    placeholder="Source column name"
                                                />
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text" id="inputGroupPrepend2">
                                                        <a
                                                            href="javascript:void(0);"
                                                            class="text-danger"
                                                            v-b-tooltip.hover
                                                            title="Delete row"
                                                            @click="deleteRow(idx)"
                                                        >
                                                            <i class="mdi mdi-trash-can font-size-18"></i>
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                            

                        </div>
                    </div>
                </div>
            </div>

        </div>
    </Modal>
</template>